import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { DownloadSignedDocumentQueryResponse, DownloadSignedDocumentQueryParams } from "../../types/DownloadSignedDocument";

/**
     * @link /api/credit-flow-backend/v1/document/view_signed
     */
export async function downloadSignedDocument (params: DownloadSignedDocumentQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<DownloadSignedDocumentQueryResponse>["data"]> {
    const { data: resData } = await client<DownloadSignedDocumentQueryResponse>({
        method: "get",
        url: `/api/credit-flow-backend/v1/document/view_signed`,
        params,
        ...options
    });
    
    return resData;
};